import React, { Component } from 'react';
import cn from 'classnames';
import './input.css';

class Input extends Component {
  render() {
    const classes = cn(
      'ui-input',
      this.props.className,
      {
        'ui_input--fluid': this.props.fluid,
      },
    );

    return (
      <div className={classes} style={this.props.style}>
        <input
          className="ui-input__input"
          type="text"
          placeholder={this.props.placeholder}
          value={this.props.value}
          onChange={this.props.onChange}
        />
      </div>
    );
  }
}

Input.propTypes = {};
Input.defaultProps = {};

export default Input;



// WEBPACK FOOTER //
// ./src/components/common/Input/Input.js